document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.aperte-card-swatch');
  if (!swatch) return;

  const src = swatch.dataset.imageSrc;
  if (!src) return; // static display swatch — let click reach the card link

  e.stopPropagation();

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  const img = card.querySelector('.card__media img');
  if (!img) return;

  const srcset = swatch.dataset.imageSrcset;
  const alt = swatch.dataset.imageAlt;

  if (srcset) img.srcset = srcset;
  img.src = src;
  if (alt !== undefined) img.alt = alt;

  card.querySelectorAll('.aperte-card-swatch').forEach(function (s) {
    s.removeAttribute('aria-pressed');
  });
  swatch.setAttribute('aria-pressed', 'true');
});

// Image-only hover swap.
// The full-card link overlay (.card__heading a::after) sits on top of the
// product image, so a plain CSS :hover on the media never fires. Instead we
// track the pointer and toggle `.aperte-img-hover` on the card-wrapper only
// while the cursor is actually over the .card__media box. CSS keys the
// second-image swap and zoom off that class. Delegated on document so it also
// covers grids re-rendered by filtering/pagination.
(function () {
  // Only on devices with a real hovering pointer (skip touch).
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

  var current = null; // the card-wrapper currently flagged

  function clear() {
    if (current) {
      current.classList.remove('aperte-img-hover');
      current = null;
    }
  }

  document.addEventListener(
    'pointermove',
    function (e) {
      var card = e.target.closest ? e.target.closest('.card-wrapper') : null;
      if (!card) {
        clear();
        return;
      }
      var media = card.querySelector('.card__media');
      if (!media) {
        clear();
        return;
      }
      var r = media.getBoundingClientRect();
      var inside =
        e.clientX >= r.left &&
        e.clientX <= r.right &&
        e.clientY >= r.top &&
        e.clientY <= r.bottom;

      if (inside) {
        if (current && current !== card) current.classList.remove('aperte-img-hover');
        card.classList.add('aperte-img-hover');
        current = card;
      } else {
        clear();
      }
    },
    { passive: true }
  );

  // Clear when the pointer leaves the document entirely.
  document.addEventListener('pointerleave', clear);
}());
